import dayjs from "dayjs";

export const formatDateFromTimestamp = (timestamp = null, format) => {
  if (timestamp)
    return dayjs(new Date(timestamp)).format(format);
  else
    return dayjs().format(format);
}

export const getTimeframe = (defaultTimeframe, defaultTimeframeKey) => {
  const customTimeframe = {};

  for (let key in defaultTimeframe) {
    customTimeframe[key] = {
      ...defaultTimeframe[key],
      checked: false
    };

    key === defaultTimeframeKey && (customTimeframe[key].checked = true);
  }

  return customTimeframe;
}